import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReportEditContainer from "../../../../Containers/ReportEditContainer";
const ReportCreateSourceId = (props) => (_jsx(ReportEditContainer, Object.assign({}, props)));
export default ReportCreateSourceId;
